var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AmazonRedshiftImportConfig_1;
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportOperation } from '../importTask';
import { ImportConfig, ImportConfigType } from './importConfig';
import { amazonRedshiftImportConfigSchemaValidation } from '../../validations.generated';
export const amazonRedshiftImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:AmazonRedshiftImportConfig',
    type: 'object',
    properties: {
        host: { type: 'string', minLength: 1 },
        port: { type: 'number', minimum: 0 },
        user: { type: 'string', minLength: 1 },
        password: { type: 'string', minLength: 1 },
        database: { type: 'string', minLength: 1 },
        startDate: { type: 'string', format: 'date-time' }
    },
    required: [] // tap-redshift requires startDate, but we supply a default value
};
let AmazonRedshiftImportConfig = AmazonRedshiftImportConfig_1 = class AmazonRedshiftImportConfig extends ImportConfig {
    constructor(startDate, columnsToUpdate) {
        super(ImportConfigType.AmazonRedshift, columnsToUpdate);
        // Although tap-redshift config requires a start_date, it is only used for incremental replication. Since we are currently only using full_table replication, we supply a default value to keep tap-redshift happy.
        this.DEFAULT_REPLICATION_VALUE_START_DATE = '1900-01-01T23:58:00Z';
        this.startDate = startDate || new Date(this.DEFAULT_REPLICATION_VALUE_START_DATE);
        JSON.validate(this, AmazonRedshiftImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite];
    }
    get needsDiscovery() {
        return true;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time-rfc'))
], AmazonRedshiftImportConfig.prototype, "startDate", void 0);
AmazonRedshiftImportConfig = AmazonRedshiftImportConfig_1 = __decorate([
    JsonSchemaV2(amazonRedshiftImportConfigSchema, amazonRedshiftImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.AmazonRedshift)
], AmazonRedshiftImportConfig);
export { AmazonRedshiftImportConfig };
//# sourceMappingURL=amazonRedshiftImportConfig.js.map